import React from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './Home'
import Contact from './Contact'
import Appointment from './Appointment'
import AboutUs from './About';
import Cro from './Cro'





const App = () => {
  return (
    <div>

      <BrowserRouter >
       
       <Routes>
     
       
 
         <Route path="/" element={<Home/>} />
      
         <Route path="/appointment" element={<Appointment />} /> 
         <Route path="/contact" element={<Contact/>} />
         <Route path="/about" element={<AboutUs/>} />
      
         
       
 
       </Routes>
 </BrowserRouter>
      
    </div>
  )
}

export default App